import { useLocalSearchParams } from "expo-router";
import { useMemo } from "react";
import { ClipsScreenContent } from "@src/features/clips";
import { useCameraDetailsData } from "@src/features/cameras/hooks/useCameraDetailsData";
import { getTimezoneFromAlarmDetail } from "@src/features/alarms/utils/alarm-utils";

export default function CameraClipsScreen() {
  const { siteId, cameraKey, clipId, clipTimestamp, timestamp, time, hour } = useLocalSearchParams<{
    siteId: string;
    cameraKey: string;
    clipId?: string;
    clipTimestamp?: string;
    timestamp?: string;
    time?: string;
    hour?: string;
  }>();

  const { alarmDetail } = useCameraDetailsData();
  const timezone = useMemo(
    () => getTimezoneFromAlarmDetail(alarmDetail) || Intl.DateTimeFormat().resolvedOptions().timeZone,
    [alarmDetail],
  );

  const deepLinkTimestamp = clipTimestamp ?? timestamp ?? time;

  if (!cameraKey || !siteId) {
    return null;
  }

  return (
    <ClipsScreenContent
      key={clipId ?? "default"}
      siteId={siteId}
      cameraKey={cameraKey}
      timezone={timezone}
      initialClipId={clipId}
      initialTimestamp={deepLinkTimestamp}
      initialHour={hour}
    />
  );
}
